// 飞兔
import { lang } from '@public/utils/filters'
export default {
  serviceType: [
    { value: 1, label: lang('外包') },
    { value: 2, label: lang('自营') }
  ],
  roleType: [
    { value: 1, label: lang('IM客服') },
    { value: 2, label: lang('400电话') }
  ],
  enabledType: [
    { value: 1, label: lang('启用') },
    { value: 2, label: lang('禁用') }
  ],
  // 满意度
  satisfactionType: [
    { value: 0, label: lang('全部') },
    { value: 1, label: lang('满意') },
    { value: 2, label: lang('一般') },
    { value: 3, label: lang('不满意') }
  ],
  // 渠道
  F_channelType: [
    { value: 0, label: lang('全部') },
    { value: 1, label: lang('PDD') },
    { value: 2, label: lang('MP') },
    { value: 3, label: lang('WEB') }
  ],
  // 性别
  genderType: [
    { value: 1, label: lang('男') },
    { value: 2, label: lang('女') }
  ],
  // 坐席状态
  receivingType: [
    { value: 1, label: lang('接待中') },
    { value: 2, label: lang('忙碌中') },
    { value: 3, label: lang('离线中') },
    { value: 4, label: lang('仅转接') }
  ],
  // 满意度结束类型
  evaluationEndType: [
    { value: 0, label: lang('默认') },
    { value: 1, label: lang('客户结束') },
    { value: 2, label: lang('客服结束') },
    { value: 3, label: lang('客户超时') },
    { value: 3, label: lang('客服超时') }
  ],
  // 是否解决
  solvedType: [
    { value: 1, label: lang('已解决') },
    { value: 2, label: lang('未解决') }
  ],
  // 功能类型
  featureType: [
    { value: 1, label: lang('发送消息') },
    { value: 2, label: lang('跳转链接') }
  ],
  // 启用模式
  enableMode: [
    { value: 1, label: lang('选定时间内显示') },
    { value: 2, label: lang('选定时间内隐藏') }
  ],
  // 渠道
  F_channelList: [
    // { value: 'buy_together', label: lang('多多-桃花岛') },
    { value: 'buy_together', label: lang('桃花岛-正向') },
    { value: 'duoduonixiang', label: lang('桃花岛-逆向') },
    { value: 'caiNiao', label: lang('菜鸟-七星潭') },
    { value: 'tikTok', label: lang('紫金山-正向') },
    { value: 'tikToknixiang', label: lang('紫金山-逆向') },
    { value: 'CaiNiaochat', label: lang('CaiNiao群聊') },
    { value: 'wechat_vip', label: lang('VIP渠道') },
    { value: 'visitor', label: lang('访客') },
    { value: 'jdw', label: lang('极地湾') },
    { value: 'kwai', label: lang('逍遥峰-KS') },
    { value: 'red', label: lang('小红书') },
    { value: 'taotian', label: lang('淘天-正向') }
  ],
  // 服务状态
  serviceStatus: [
    { value: 1, label: lang('接通会话') },
    { value: 2, label: lang('未接通会话') },
    { value: 3, label: lang('排队剔除') }
  ],
  // 会话结束类型
  sessionEndType: [
    { value: 1, label: lang('客户结束') },
    { value: 2, label: lang('客服结束') }
  ],
  // 账号体系类型
  dataSourceType: [
    { value: 'FT_IM', id: 1, label: lang('飞兔') },
    { value: 'JMS_OS', id: 2, label: lang('JMS_外包') },
    { value: 'JMS_SE', id: 3, label: lang('JMS_自营') }
  ],
   // 通用是/否
   universalWhether: [
    { value: 1, label: lang('是') },
    { value: 2, label: lang('否') }
  ],
  // 评价星级
  levelOption: [
    { value: 1, label: lang('1星') },
    { value: 2, label: lang('2星') },
    { value: 3, label: lang('3星') },
    { value: 4, label: lang('4星') },
    { value: 5, label: lang('5星') }
  ],
  DAY_Dimension:[
    { value: 'DAY', label: lang('按日'), name: lang('按日') },
    { value: 'WEEK', label: lang('按周'), name: lang('按周') },
    { value: 'MONTH', label: lang('按月'), name: lang('按月') }
  ]
}
